import _asyncToGenerator from "/portal/Vue/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js";
import _typeof from "/portal/Vue/node_modules/@babel/runtime-corejs2/helpers/typeof.js";
import _regeneratorRuntime from "/portal/Vue/node_modules/@babel/runtime-corejs2/regenerator/index.js";
import "core-js/modules/es6.function.name.js";
import "core-js/modules/es6.object.assign.js";
import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.regexp.constructor.js";
import "core-js/modules/es6.number.constructor.js";
import "core-js/modules/es6.string.ends-with.js";
import "core-js/modules/es6.regexp.split.js";
import "core-js/modules/es6.regexp.match.js";
import "core-js/modules/es6.regexp.replace.js";
/* eslint-disable brace-style */
/* eslint-disable no-use-before-define */

/// ///////////////////////////////////////////////////////////////////////
//          Функции, реализующие общие операции с объектом
/// ///////////////////////////////////////////////////////////////////////

import Vue from 'vue';
// import Router from 'router'
import Quasar from 'quasar/src/vue-plugin.js';;
import { i18n } from 'boot/i18n';
import { axiosInst as axios } from 'boot/axios';
import { MODE, ENTRY, CARD } from 'pages/aftmixin';
import { LANGS, locale2code } from 'components/LangSelector';
import { isInstanceOfDate, iso2bro, isoWoTime2bro12, bro2iso } from 'components/formatting';
var ACCNAME_INIT = 'Unauthorized';
function msgerror(msg, additionalInfo) {
  console.error(msg);
  if (additionalInfo) console.error('additionalInfo:', additionalInfo);
  Vue.prototype.$q.notify({
    icon: 'error',
    color: 'negative',
    message: msg
  });
}
function msgdone(msg) {
  Vue.prototype.$q.notify({
    icon: 'done',
    color: 'positive',
    message: msg
  });
}

// obj, mess - можно менять местами, опускать, передавать в один из них строку, а в другой Error
function messageNegative(obj, mess) {
  // console.error('obj=', obj, 'mess=', mess) // msgerror пишет для отладки

  msgerror(obj && typeof obj === 'string' && obj || mess && typeof mess === 'string' && mess || obj && obj.message ||
  // тип Error
  mess && mess.message ||
  // тип Error
  'Unknown error', obj && typeof obj !== 'string' ? obj : mess && typeof mess !== 'string' ? mess : null);
  return true;
}
function AppError(message) {
  this.message = message;
  this.stack = Error().stack;
}
AppError.prototype = Object.create(Error.prototype);
AppError.prototype.name = 'AppError';
export function systemError(error
/*
Необязательный параметр.
Если это AppError, то текст сообщения будет из него, а в ином случае - стандартный текст,
маскирующий страшный текст системных ошибок от пользователя.
*/) {
  var errText = error instanceof AppError ? error.message : i18n.t('com.msg.systemError');
  var additionalInfo = error instanceof AppError ? null : error;
  messageNegative(errText, additionalInfo /* additional info for debug in console */);
}
export function checkResponseAppError(response) {
  var errText = response && response.data && response.data.ErrText;
  if (errText) throw new AppError(errText);
}
function examResponseError(obj, response) {
  // console.log(' / db_action resp:')
  // console.log(response.data)
  if (_typeof(response.data) === 'object' && !Array.isArray(response.data) && 'ErrText' in response.data) {
    // obj.afterrText = response.data.ErrText
    // obj.afterrCode = response.data.ErrCode
    // obj.aftError(response.data.ErrText)
    messageNegative(response.data.ErrText);
    if (obj) {
      obj.aftloading = false;
    }
    return true;
  }
  return false;
}
function AFT() {
  this.accountId = null;
  this.accountLogin = null;
  this.avaFileId = null;
  // this.accountName = null;
  this.token = null;
  this.accountRoles = null;
  this.clickrow = null; // cardTab row, по которому кликнули мышкой (в том числе и при выборе экшена в строке таблицы)
  this.objTab = null; // vue-объект, из табличной карточки которого перешли на страницу карточки записи (это уже другой vue)
  this.objRec = null; // vue-объект карточки записи
  this.routeHistory = []; // массив адресов выполненных переходов (в рамках auth - лейаута)
  this.objListOnInit = []; // список объектов, которые будут проинициализированы при переходе на страницу

  this.eventBus = new Vue();

  // *** GVN
  this.isexecutor = null;
  this.g = {
    auth: {},
    // login info
    obj: {},
    // data.aftenv cash
    enum: [],
    // enum cash
    aftobj: {},
    // aft-objects access cash
    com: {} // common cashes
  };

  // ----------------------------------------------------------------------------
  //                               initObject
  //
  // Восстанавливает obj.aftenv из кэша.
  // Если кэша еще нет, создает кэш, подтягиваем доступные экшены из БД,
  // формирует obj.aftenv.actsRow && obj.aftenv.actsTab.
  // ----------------------------------------------------------------------------

  this.initObject = function (obj) {
    function getActobj(dact) {
      // Формирует объект-описание экшена {act:,icon:,scope:,fun:} на основе:
      //    1. Описания экшена разработчиком,
      //    2. Считанной информации из БД
      //    3. Дефолтовых соглашений
      var actobj = {};
      if (_typeof(dact) === 'object') {
        Object.assign(actobj, dact);
      } else {
        // если не объект описания, то - имя экшена
        actobj.act = dact;
      }
      // Проставим дефолтовые значения
      for (var i = 0; i < obj.aftenv.acts.length; i++) {
        if (obj.aftenv.acts[i].code === actobj.act) {
          if (typeof actobj.icon === 'undefined') {
            actobj.icon = obj.aftenv.acts[i].icon;
          }
          if (typeof actobj.scope === 'undefined') {
            actobj.scope = obj.aftenv.acts[i].onrow === 'Y' ? 'row' : 'tab';
          }
        }
      }
      if (typeof actobj.scope === 'undefined') {
        actobj.scope = 'row';
      }
      if (typeof actobj.fun === 'undefined') {
        actobj.fun = 'aftAction';
      }
      return actobj;
    } // --- getActobj

    // Если есть кэш, берем энвайромент из него
    if (obj.aftobjCode in this.g.obj) {
      obj.aftenv = this.g.obj[obj.aftobjCode].env;
      if ('recRse' in this.g.obj[obj.aftobjCode].env) {
        obj.recRse = this.g.obj[obj.aftobjCode].env.recRse;
      }
    }
    // Кэша нет, создаем кэш, подтягиваем доступные экшены из БД
    else {
      if (!this.examClientAuth()) {
        return;
      } // Если объект работает в неавторизованном лэйауте, в базу не лезем

      this.g.obj[obj.aftobjCode] = {};
      this.g.obj[obj.aftobjCode].env = obj.aftenv;
      if ('recRse' in obj) {
        this.g.obj[obj.aftobjCode].env.recRse = obj.recRse;
      }
      axios.post('/select_aftacts', {
        ObjCode: obj.aftobjCode
      }).then(function (response) {
        // console.log('response.data:');
        // console.log(response.data);
        obj.aftenv.acts = response.data;

        // --- Формируем списки экшенов для строки таблицы и всей таблицы

        obj.aftenv.actsRow = [];
        obj.aftenv.actsTab = [];
        if (obj.aftobjActs.length) {
          // Если есть список экшенов от разработчика
          for (var i = 0; i < obj.aftobjActs.length; i++) {
            var actobj = getActobj(obj.aftobjActs[i]);
            if (actobj.scope.indexOf('row') !== -1) {
              obj.aftenv.actsRow.push(actobj);
            }
            if (actobj.scope.indexOf('tab') !== -1) {
              obj.aftenv.actsTab.push(actobj);
            }
          }
        } else {
          // Описания от разработчика нет - формируем на основании инф-и из БД
          for (var _i = 0; _i < obj.aftenv.acts.length; _i++) {
            if (obj.aftenv.acts[_i].onrow === 'Y') {
              var newact = {
                act: obj.aftenv.acts[_i].code,
                icon: obj.aftenv.acts[_i].icon,
                scope: 'row',
                fun: 'aftAction'
              };
              obj.aftenv.actsRow.push(newact);
            } else {
              var _newact = {
                act: obj.aftenv.acts[_i].code,
                icon: obj.aftenv.acts[_i].icon,
                scope: 'tab',
                fun: 'aftAction'
              };
              obj.aftenv.actsTab.push(_newact);
            }
          }
        }
      }).catch(function (error) {
        systemError(error);
      });
    }
  };

  // ----------------------------------------------------------------------------
  //                              initAFTObjectsOnAccess
  // ----------------------------------------------------------------------------

  this.initAFTObjectsOnAccess = function () {
    var _this = this;
    if (!Object.keys(this.g.aftobj).length) {
      return axios.post('/select_aftobjectsonaccess').then(function (response) {
        var objs = response.data;
        _this.g.aftobj = {};
        for (var i = 0; i < objs.length; i++) {
          _this.g.aftobj[objs[i]] = {};
        }
        ;
        return true;
      }).catch(function (error) {
        systemError(error);
        return false;
      });
    }
    ;
    return true;
  };

  // глубокое (рекурсивное) клонирование объекта (копирование значений)
  this.deepCopyFrom = function (from, to /* если не указывать, то возвращается клон from */, copyExistingPropertiesToo /* если не указывать (по-умолчанию), то будут скопированы только новые свойства */) {
    if (from === null || _typeof(from) !== 'object') return from;
    if (from.constructor !== Object && from.constructor !== Array) return from;
    if (from.constructor === Date || from.constructor === RegExp || from.constructor === Function || from.constructor === String || from.constructor === Number || from.constructor === Boolean) {
      return new from.constructor(from);
    }
    to = to || new from.constructor();
    for (var name in from) {
      if (Object.prototype.hasOwnProperty.call(from, name)) {
        to[name] = typeof to[name] === 'undefined' || copyExistingPropertiesToo ? this.deepCopyFrom(from[name], null) : to[name];
      }
    }
    return to;
  };

  // рекурсивный обход свойств объекта и выполнение функции для каждого простого значения
  this.forAllProps = function (obj, func) {
    var handledFlag = 'temp__isAlreadyHandled__'; // защита от зацикливания ссылок
    runProp(obj);
    function runProp(o, stack) {
      var propertyPath;
      for (var prop in o) {
        var isLeaf = void 0;
        if (o[prop] !== null && _typeof(o[prop]) === 'object') {
          // т.к. typeof null === 'object'
          if (isInstanceOfDate(o[prop])) {
            // дата является листом дерева объектов, а не узлом!
            isLeaf = true;
          } else {
            // обработать вложенный объект
            isLeaf = false;
            if (!o[prop][handledFlag]) {
              Object.defineProperty(o[prop], handledFlag, {
                value: true,
                writable: false,
                configurable: true
              });
              if (!stack) {
                propertyPath = 'rootObject.' + prop;
              } else {
                propertyPath = stack + '.' + prop;
              }
              runProp(o[prop], propertyPath);
            } else {
              propertyPath = stack + '.' + prop;
              console.error('Циклическая ссылка. Свойство: ' + propertyPath);
            }
            delete o[prop][handledFlag];
          }
        } else {
          isLeaf = true;
        }
        if (isLeaf) {
          func(o, prop);
        }
      }
    }
  };

  // ----------------------------------------------------------------------------
  //                               dbAction
  // ----------------------------------------------------------------------------

  this.postDbAction = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(objcode, act, data, axiosConfig) {
      var _this2 = this;
      var dataForAxios, dataForJson;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            // преобразование данных перед отправкой на сервер
            dataForAxios = {
              ObjCode: objcode,
              Action: act
            };
            if (typeof data !== 'undefined') {
              if (data === null) {
                dataForJson = null; // что соответствует вызову серверной процедуры с параметром None
              } else {
                dataForJson = this.deepCopyFrom(data);
                this.forAllProps(dataForJson, function (o, prop) {
                  if (isInstanceOfDate(o[prop])) {
                    o[prop] = bro2iso(o[prop]);
                    o[prop + '__type'] = 'datetime';
                  }
                });
              }
              dataForAxios.Data = dataForJson;
            } // если data undefined, то не добавлять dataForAxios.Data, что соответствует вызову серверной процедуры без параметров
            return _context.abrupt("return", axios.post('/db_action', dataForAxios, axiosConfig)

            // преобразование данных после получения их с сервера
            .then(function (response) {
              var dataFromJson = response.data;
              _this2.forAllProps(dataFromJson, function (o, prop) {
                var typeSuffix = '__type';
                if (prop.endsWith(typeSuffix)) {
                  var valKey = prop.substring(0, prop.length - typeSuffix.length);
                  if (o[prop] === 'datetime') {
                    o[valKey] = iso2bro(o[valKey]); // преобразование типа
                  } else if (o[prop] === 'date') {
                    o[valKey] = isoWoTime2bro12(o[valKey]);
                  } else {
                    console.error('Unknown __type === ' + o[prop]);
                  }
                  delete o[prop]; // убрать указание типа, т.к. оно уже не нужно
                }
              });
              response.data = dataFromJson;
              return response;
            }));
          case 3:
          case "end":
            return _context.stop();
        }
      }, _callee, this);
    }));
    return function (_x, _x2, _x3, _x4) {
      return _ref.apply(this, arguments);
    };
  }();
  this.dbAction = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2(obj, objcode, act, data, resfld, axiosConfig) {
      var _this3 = this;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            return _context2.abrupt("return", this.postDbAction(objcode, act, data, axiosConfig).then(function (response) {
              if (examResponseError(obj, response)) {
                return 0;
              }
              // obj[resfld] = response.data
              if (resfld) {
                obj.aftParseObjectField(resfld).obj[obj.aftParseObjectField(resfld).fld] = response.data;
              }
              return 1;
            }).catch(function (error) {
              _this3.treateServerError(obj, error);
              return 0;
            }));
          case 1:
          case "end":
            return _context2.stop();
        }
      }, _callee2, this);
    }));
    return function (_x5, _x6, _x7, _x8, _x9, _x10) {
      return _ref2.apply(this, arguments);
    };
  }();

  // ----------------------------------------------------------------------------
  //                              Report
  // ----------------------------------------------------------------------------

  this.Report = function (repcode, repName, data) {
    var fileDownLoad = require('js-file-download');
    axios.post('/db_action', {
      ObjCode: repcode,
      Action: 'report',
      Data: data
    }, {
      responseType: 'blob'
    }).then(function (response) {
      if (!examResponseError(null, response)) {
        fileDownLoad(response.data, repName + '.xlsx');
      }
    }).catch(function (error) {
      systemError();
    });
  };
  this.Statistic = function (repcode, data) {
    var _this4 = this;
    axios.post('/db_action', {
      ObjCode: repcode,
      Action: 'statistic',
      Data: data
    }).then(function (response) {
      _this4.headers = response.headers;
      _this4.data = response.data;
      return true;
    }).catch(function (error) {
      systemError(error);
      _this4.headers = [];
      _this4.data = [];
      return false;
    });
  };

  // ----------------------------------------------------------------------------
  //                              initEnum
  // ----------------------------------------------------------------------------

  this.initEnum = function () {
    var _this5 = this;
    if (!this.g.enum.length) {
      var lang = locale2code(i18n.locale);
      return axios.post('/select_enum', {
        langcode: lang
      }).then(function (response) {
        _this5.g.enum = response.data;
        return true;
      }).catch(function (error) {
        systemError(error);
        return false;
      });
    }
    ;
    return true;
  };

  // ----------------------------------------------------------------------------
  //                                 getEnumList
  // ----------------------------------------------------------------------------

  this.getEnumList = function (obj, arrfield, enumcode) {
    // Формируем результирующий массив для запрашиваемого кода
    for (var i = 0; i < this.g.enum.length; i++) {
      if (this.g.enum[i].code === enumcode) {
        obj[arrfield].push(this.g.enum[i]);
      }
    }
    ;
  };
  this.getEnumRecord = function (enumcode, enumfield, fieldvalue) {
    for (var i = 0; i < this.g.enum.length; i++) {
      if (this.g.enum[i].code === enumcode && this.g.enum[i][enumfield] === fieldvalue) {
        return this.g.enum[i];
      }
      ;
    }
    ;
    return null;
  };

  // ----------------------------------------------------------------------------
  //                               gotoPage
  // ----------------------------------------------------------------------------

  // Функция вызывается из Роутера перед началом рендеринга пейджа.

  this.gotoPage = function (to, from) {
    // Обнулим список объектов, которые будут проинициализированы при переходе на эту страницу
    this.objListOnInit = [];
    this.routeHistory.push(to);
  };

  // ----------------------------------------------------------------------------
  //                               gotoRoute
  // ----------------------------------------------------------------------------

  this.gotoRoute = function (obj, act, row) {
    function getparam() {
      if (typeof row === 'undefined' || !row) {
        return 0;
      }
      return row.id;
    }
    if (!obj.inMode(MODE.recpage)) {
      return;
    }

    // Поищем маршрут для заданного экшена в настройке aftobjRoutes
    // ...
    // Вряд ли оправданный механизм, все переходы делаются, как правило по ссылке с явным указанием маршрутов и параметров

    // if ( obj.aftobjRoutes ) {
    //   for(let i=0;i<obj.aftobjRoutes.length;i++) {
    //     if ( obj.aftobjRoutes[i][0] === obj.aftcard && obj.aftobjRoutes[i][1] === act) {
    //       // Переход по адресу, заданному в соотв. параметре объекта при инициализации
    //       obj.$router.push( { name: obj.aftobjRoutes[i][3], params: {id:getparam(), card:aftcard} } )
    //       return
    //     }
    //   }
    // }

    // Предопределенные переходы для стандартных экшенов

    // ..... переход на карточку записи.
    //       - имя маршрута:  код объекта + 'Rec'
    if (obj.aftStrIn(act, 'actAdd,actView,actUpdate')) {
      var aftcard = act === 'actAdd' ? CARD.add : act === 'actUpdate' ? CARD.upd : CARD.view;
      obj.$router.push({
        name: obj.aftobjCode + 'Rec',
        params: {
          id: getparam(),
          card: aftcard
        }
      });
      return;
    }

    // ..... завершение ввода (не потоковый ввод)/редактирования по 'actOk'для объектов с entry = cardTab & cardList
    //       - для entry == cardTab в качестве имени маршрута используется код объекта
    //       - для entry == cardList код объекта + 'List'
    // ..... или нажат крест ('actReturn') для объекта с isTabEntry
    //       - нельзя просто obj.$router.go(-1), т.к. возможен вход в cardUpdate из внешней ссылки, а не из cardTab
    //         в этом случае - назад дороги нет
    if (act === 'actOk' && obj.isTabEntry() && !obj.inMode(MODE.Stream) || act === 'actReturn' && obj.isTabEntry()) {
      var rname = obj.aftobjEntry === ENTRY.cardTab ? obj.aftobjCode + 'Tab' : obj.aftobjCode + 'List';
      obj.$router.push({
        name: rname
      });
      return;
    }

    // ..... возврат на предыдущую страницу
    if (act === 'actReturn') {
      if (this.routeHistory.length > 1) {
        obj.$router.go(-1);
      } else {
        obj.$router.push('/auth');
      }
    }
  };

  // ----------------------------------------------------------------------------
  //                               initCommonCashes
  // ----------------------------------------------------------------------------

  this.initCommonCashes = /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
    var res;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return this.initAFTObjectsOnAccess();
        case 2:
          res = _context3.sent;
          if (!res) {
            _context3.next = 7;
            break;
          }
          _context3.next = 6;
          return this.initEnum();
        case 6:
          res = _context3.sent;
        case 7:
          ;
          if (!res) {
            systemError();
          }
          ;
          return _context3.abrupt("return", res);
        case 11:
        case "end":
          return _context3.stop();
      }
    }, _callee3, this);
  }));

  // ----------------------------------------------------------------------------
  //                                  setLang
  // ----------------------------------------------------------------------------

  this.setLang = function (langcode) {
    // console.log('changeLang i18n.locale: ' + i18n.locale + '  lang:' + lang)
    i18n.locale = LANGS[langcode].locale;

    // Язык Квазара
    import('quasar/lang/' + LANGS[langcode].locale).then(function (lang) {
      Quasar.lang.set(lang.default);
    });

    // Сохраним установленный язык в куках
    var date = new Date();
    date.setDate(date.getDate() + 100);
    setCookie('LANG', langcode, {
      expires: date.toUTCString
    });
  };

  // ----------------------------------------------------------------------------
  //                                changeLang
  // ----------------------------------------------------------------------------

  this.changeLang = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee4(langcode) {
      var res, curobj;
      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            res = 1; // console.log('this.changeLang: ' + langcode)
            // Кинем текущему объекту событие evnBeforeChangeLang
            curobj = this.objListOnInit ? this.objListOnInit[0] : null;
            if (curobj && 'eventCapture' in curobj) {
              curobj.eventCapture('evnBeforeChangeLang');
            }
            // Кинем событие в шину
            this.eventBus.$emit('evnBeforeChangeLang');
            this.setLang(langcode);

            // Сбросим кэш объектов
            this.g.obj = {};

            // Если авторизованы, поменяем язык в л/к и перечитаем enum cash
            if (!this.examClientAuth()) {
              _context4.next = 14;
              break;
            }
            this.postDbAction('acsaccount', 'update', null) // null признак того, что изменяется только язык
            .catch(function () {
              systemError();
            });
            this.g.enum = [];
            _context4.next = 11;
            return this.initEnum();
          case 11:
            res = _context4.sent;
            if (!res) {
              systemError();
            }
            ;
          case 14:
            if (!(curobj && 'eventCapture' in curobj)) {
              _context4.next = 17;
              break;
            }
            _context4.next = 17;
            return curobj.eventCapture('evnAfterChangeLang');
          case 17:
            this.eventBus.$emit('evnAfterChangeLang');
            return _context4.abrupt("return", res);
          case 19:
          case "end":
            return _context4.stop();
        }
      }, _callee4, this);
    }));
    return function (_x11) {
      return _ref4.apply(this, arguments);
    };
  }();

  // ----------------------------------------------------------------------------
  //                           authorization examAuthorization
  // ----------------------------------------------------------------------------

  // --- Инициализация параметров среды на основании информации по авторизации на клиенте
  // --- в том числе и ряда старых дублируемых свойств для приемственности
  this.initAuthInfo = function () {
    // *** Атавизм
    this.accountName = this.g.auth.accName;
    this.accountId = this.g.auth.accId;
    this.accountLogin = this.g.auth.accLogin;
    this.avaFileId = this.g.auth.avaFileId;
    this.token = this.g.auth.token;
    this.accountRoles = this.g.auth.roles;
    this.isexecutor = this.g.auth.isexecutor;
    this.roles = this.accountRoles ? this.accountRoles.split(';') : [];

    // Заполняем список доступных объектов
    var objs = this.g.auth.acsobjs;
    this.g.aftobj = {};
    for (var i = 0; i < objs.length; i++) {
      this.g.aftobj[objs[i]] = {};
    }
    ;
  };

  // --- Сохраняет на клиенте в g.auth все параметры авторизации, полученные с бекэнда 
  this.setAuthInfo = function (response) {
    this.g.auth.accName = response.data.AccountName;
    this.g.auth.accId = response.data.AccountId;
    this.g.auth.accLogin = response.data.AccountLogin;
    this.g.auth.avaFileId = response.data.avaFileId;
    this.g.auth.userType = response.data.UserType;
    this.g.auth.langCode = response.data.langcode;
    this.g.auth.localeCode = response.data.localeCode;
    this.g.auth.gmtPlus = response.data.gmtPlus;
    this.g.auth.custid = response.data.custid;
    this.g.auth.roles = response.data.AccountRoles ? response.data.AccountRoles.split(';') : [];
    this.g.auth.customerServicesCount = response.data.customerServicesCount;
    this.g.auth.token = response.data.Token;
    this.g.auth.isexecutor = response.data.isexecutor;
    this.g.auth.roles = response.data.AccountRoles;
    this.g.auth.acsobjs = response.data.AFTObjectsOnAccess;
    this.initAuthInfo();
    this.initCommonCashes();

    // Сохраняем в localStorage текущий логин
    localStorage["smart$login"] = this.g.auth.accLogin;
  };

  // --- Авторизация на бекенде с установкой параметров авторизации на клиенте
  this.authorization = /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee5(rec) {
      var _this6 = this;
      return _regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            return _context5.abrupt("return", axios.post('/auth_login', rec).then(function (response) {
              // console.log(response);
              if (!response.data.AccountId) {
                return 0;
              } else {
                _this6.setLang(response.data.langcode || 'RU'); // текущий язык устанавливаем из языка пользователя
                _this6.setAuthInfo(response);
                return _this6.accountId;
              }
            }).catch(function (error) {
              systemError(error);
              return false;
            }));
          case 1:
          case "end":
            return _context5.stop();
        }
      }, _callee5);
    }));
    return function (_x12) {
      return _ref5.apply(this, arguments);
    };
  }();

  // --- Проверяет установлены или нет клиентские параметры авторизации
  this.examClientAuth = function () {
    return !!this.g.auth.accName && this.g.auth.accName !== ACCNAME_INIT;
  };

  // --- Очищает клиентские параметры авторизации
  this.clearClientAuth = function () {
    for (var par in this.g.auth) {
      this.g.auth[par] = null;
    }
  };

  // --- Проверяет прошел ли текущий пользователь авторизацию
  // --- При проверке на бекэнде подтягиваем на клиента параметры авторизации
  this.examAuthorization = /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
    var _this7 = this;
    return _regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) switch (_context6.prev = _context6.next) {
        case 0:
          if (!this.examClientAuth()) {
            _context6.next = 3;
            break;
          }
          if (!(localStorage["smart$login"] === this.g.auth.accLogin)) {
            _context6.next = 3;
            break;
          }
          return _context6.abrupt("return", true);
        case 3:
          return _context6.abrupt("return", axios.post('/auth_verify', {}).then(function (response) {
            if (response.data.AccountId) {
              _this7.setAuthInfo(response);
              return true;
            }
            ;
            return false;
          }).catch(function (error) {
            // console.log('error:');
            // console.log(error);
            _this7.accountName = '';
            // 401 - устанавливает backend, если ошибка авторизации
            if (error.response.status !== 401) {
              systemError();
            }
            return false;
          }));
        case 4:
        case "end":
          return _context6.stop();
      }
    }, _callee6, this);
  }));

  // ----------------------------------------------------------------------------
  //                                logout
  // ----------------------------------------------------------------------------

  this.logout = function (obj) {
    var _this8 = this;
    axios.get('/auth_clear').then(function (response) {
      _this8.accountId = 0;
      _this8.accountName = null;

      // Сбросить кэши !
      _this8.g.auth = {};
      _this8.g.obj = {};
      _this8.g.enum = [];
      _this8.g.aftobj = {};
      localStorage["smart$login"] = 'undefined';

      // Vue.prototype.$router.push('/')
      obj.$router.push({
        name: 'login'
      });
    }).catch(function (error) {
      systemError(error);
    });
  };

  // ----------------------------------------------------------------------------
  //                                getBackendURL
  // ----------------------------------------------------------------------------

  this.getBackendURL = function () {
    return axios.defaults.baseURL;
  };

  // ----------------------------------------------------------------------------
  //                messagePositive messageNegative errFatal
  // ----------------------------------------------------------------------------

  this.messagePositive = function (obj, mess) {
    if (typeof obj === 'string') {
      msgdone(obj);
    } else {
      msgdone(mess);
    }
    return true;
  };
  this.messageNegative = function (obj, mess) {
    return messageNegative(obj, mess);
  };
  this.systemError = function (error) {
    return systemError(error);
  };
  this.errFatal = function (mess) {
    // aftloading = false
    msgerror('Fatal error. ' + mess);
    throw new Error('AFT fatal error: ' + mess);
  };
  this.treateServerError = function (obj, err) {
    console.error(err);
    obj.aftloading = false;
    if (err.response && err.response.status === 401) {
      msgerror(i18n.t('com.msg.reqauth'));
      // obj.$router.push('/login') Переход делается в axios
    } else {
      systemError();
    }
    ;
  };

  // ----------------------------------------------------------------------------
  //                               standartAction
  // ----------------------------------------------------------------------------

  this.standartAction = function (obj, act, row, fldname) {
    // console.log('standartAction act: ' + act);
    // console.log(row)

    switch (act) {
      case 'actSelect':
        // if ('aftfrmRse' in obj) {
        //   obj.aftcard = 'cardRse'
        //   obj.aftfrmRse = true
        //   break
        // }
        this.tabSelect(obj);
        break;
      case 'actSelectAddle':
        this.tabSelect(obj);
        break;
      case 'actFreshAddle':
        this.standartAction(obj, 'actSelect');
        break;
      case 'actRepairAddle':
        this.tabRepairAddle(obj);
        break;
      case 'actAdd':
        this.tabAdd(obj);
        break;
      case 'actUpdate':
      case 'actView':
        this.tabViewUpdate(obj, act, row);
        break;
      case 'actReturn':
        this.gotoRoute(obj, act, row);
        break;
      case 'actOk':
        this.recOk(obj);
        break;
      case 'actDelete':
      case 'actDeleteP':
      case 'actDeleteM':
        this.tabDelete(obj, act);
        break;
      case 'actClearRec':
      case 'actClearRse':
        this.recClear(obj, act);
        if (act === 'actClearRse') {
          this.standartAction(obj, 'actSelect');
        }
        break;
      case 'actUpdateField':
        this.fldUpdate(obj, row, fldname);
        break;
      case 'actExcel':
        this.tabExcel(obj);
        break;
      default:
        this.errFatal('Illegal standart action: "' + obj.aftcard + act);
    }
  };

  // ----------------------------------------------------------------------------
  //                               choiceAction
  // ----------------------------------------------------------------------------

  this.choiceAction = function (obj, row) {
    obj.aftloading = false;
  };

  // ----------------------------------------------------------------------------
  //                               tabSelect
  // ----------------------------------------------------------------------------

  this.tabSelect = function (obj) {
    var _this9 = this;
    if (obj.aftord) {
      obj.recRse.aftord = [];
      for (var f in obj.aftord) {
        var ord = 0,
          dir = null;
        if (obj.aftord[f].lLeft) {
          ord = parseInt(obj.aftord[f].lLeft);
          dir = ' DESC';
        }
        ;
        if (obj.aftord[f].lRight) {
          ord = parseInt(obj.aftord[f].lRight);
        }
        ;
        if (ord) {
          obj.recRse.aftord.push({
            fld: f,
            ord: ord,
            dir: dir
          });
        }
        ;
      }
      ;
    }
    ;
    obj.aftenv.data = [];
    obj.aftenv.selected = [];
    var data = 'recRse' in obj ? obj.recRse : undefined;
    this.postDbAction(obj.aftobjCode, 'select', data).then(function (response) {
      if (examResponseError(obj, response)) {
        return 0;
      }
      obj.aftenv.data = response.data;
      if ('eventCapture' in obj) {
        obj.eventCapture('evnAfterSelect');
      }
      ;

      // Для всех деталей с режимом initCard вызовем actSelect
      if (obj.aftenv.data.length && obj.aftobjDetails) {
        // Если нет текущей (помеченной) записи, пометим 1-ю
        if (!obj.aftenv.selected.length) {
          obj.aftenv.selected.push(obj.aftenv.data[0]);
        }
        for (var i = 0; i < obj.aftobjDetails.length; i++) {
          var dtl = obj.aftobjDetails[i];
          if (dtl.inMode(MODE.initCard) && dtl.loadFk(obj.aftenv.selected[0])) {
            obj.aftloading = true; // деталь его сбросит, пока подперт только один уровень мастер - деталь
            var evnres = true;
            if ('eventCapture' in dtl) {
              evnres = dtl.eventCapture('evnBeforeDetailRenew', obj.aftenv.selected[0]);
            }
            ;
            if (evnres) {
              dtl.aftAction('actSelect');
              if ('eventCapture' in dtl) {
                dtl.eventCapture('evnAfterDetailRenew', obj.aftenv.selected[0]);
              }
              ;
            } else {
              obj.aftloading = false;
            }
          }
        }
      } else {
        obj.aftloading = false;
      }

      // Если это деталь, надо сбросить флаг у мастера
      if (obj.aftobjMaster) {
        obj.aftobjMaster.aftloading = false;
      }
    }).catch(function (error) {
      _this9.treateServerError(obj, error);
    });
  };

  // ----------------------------------------------------------------------------
  //                               tabExcel
  // ----------------------------------------------------------------------------

  this.tabExcel = function (obj) {
    var _this10 = this;
    var fileDownLoad = require('js-file-download');
    var d = obj.aftenv.selected.length ? obj.aftenv.selected : obj.aftenv.data;
    axios.post('export_excel', {
      objcode: obj.aftobjCode,
      objname: obj.aftCardTabLabel,
      data: d,
      sortby: obj.aftpagination.sortBy,
      desc: obj.aftpagination.descending,
      cols: obj.columns
    }, {
      responseType: 'blob'
    }).then(function (response) {
      fileDownLoad(response.data, obj.aftCardTabLabel + '.xlsx');
    }).catch(function (error) {
      _this10.treateServerError(obj, error);
    });
  };

  // ----------------------------------------------------------------------------
  //                               setRecContent
  //
  // Наполнение данными карточки записи
  // Переключение cardUpdate -> cardView, если: aftLicence('actUpdate') == false
  // ----------------------------------------------------------------------------

  this.setRecContent = /*#__PURE__*/function () {
    var _ref7 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee7(obj, row) {
      var _this11 = this;
      var selrow;
      return _regeneratorRuntime.wrap(function _callee7$(_context7) {
        while (1) switch (_context7.prev = _context7.next) {
          case 0:
            if (obj.inMode(MODE.recpage)) {
              // В режиме пейджа из параметров маршрута пытаемся перенести данные в cardAdd
              if (obj.$route.params) {
                Object.assign(obj.recAdd, obj.$route.params);
                // obj.recAdd.id = obj.$route.params.id  ... а если не только id...
              }
            } else {
              // В режиме диалога перенесем значения полей из табличной записи
              selrow = row || obj.aftenv.dblclickrow || obj.aftenv.clickrow || obj.aftenv.selected[0];
              Object.assign(obj.recAdd, selrow);
              obj.aftenv.dblclickrow = null;
            }

            // Если задан режим MODE.recread, полезем в БД
            if (!obj.inMode(MODE.recread)) {
              _context7.next = 7;
              break;
            }
            _context7.next = 4;
            return this.postDbAction(obj.aftobjCode, 'recread', obj.recAdd).then(function (response) {
              if (examResponseError(obj, response)) {
                return false;
              }
              Object.assign(obj.recAdd, response.data[0]);
              if ('eventCapture' in obj) {
                obj.eventCapture('evnAfterRead');
              }
              ;

              // Если установлена obj.aftcard == cardUpdate, то проверяем доступ к actUpdate,
              // если доступа нет, устанавливаем текущей cardView
              // ! Принципиально эту проверку делать после инициализации карточки данными,
              // т.к. результат ownLicence м.б. привязан к конкретным данным
              // Также принципиально предварительно скинуть aftloading !
              obj.aftloading = false;
              if (obj.aftcard === CARD.upd && !obj.aftLicence('actUpdate')) {
                obj.aftcard = CARD.view;
                // this.aftlabCardRec = this.aftobjName + this.$t('com.lab.viewrec')
              }
              return true;
            }).catch(function (error) {
              _this11.treateServerError(obj, error);
              return false;
            });
          case 4:
            return _context7.abrupt("return", _context7.sent);
          case 7:
            obj.aftloading = false;
            if (obj.aftcard === CARD.upd && !obj.aftLicence('actUpdate')) {
              obj.aftcard = CARD.view;
              // this.aftlabCardRec = this.aftobjName + this.$t('com.lab.viewrec')
            }
          case 9:
            return _context7.abrupt("return", true);
          case 10:
          case "end":
            return _context7.stop();
        }
      }, _callee7, this);
    }));
    return function (_x13, _x14) {
      return _ref7.apply(this, arguments);
    };
  }();

  // ----------------------------------------------------------------------------
  //                               tabAdd
  // ----------------------------------------------------------------------------

  this.tabAdd = function (obj) {
    // Если есть помеченная - ввод копированием
    if (obj.aftenv.selected.length) {
      for (var key in obj.recAdd) {
        if (key in obj.aftenv.selected[0]) {
          obj.recAdd[key] = obj.aftenv.selected[0][key];
        }
      }
      ;
    }
    ;
    // Либо отдельная страница либо модальный диалог
    if (obj.inMode(MODE.recpage)) {
      this.objTab = obj;
      this.gotoRoute(obj, 'actAdd');
    } else {
      obj.aftcardRem = obj.aftcard;
      obj.aftcard = 'cardAdd';
      obj.aftfrmRec = true;
    }
  };

  // ----------------------------------------------------------------------------
  //                               tabViewUpdate
  // ----------------------------------------------------------------------------

  this.tabViewUpdate = function (obj, act, row) {
    var card = act === 'actView' ? CARD.view : CARD.upd;

    // console.log('tabViewUpdate act: ' + act);
    // console.log(row)

    if (obj.inMode(MODE.recpage)) {
      // Если режим пейджа, переходим на страницу из маршрута
      this.objTab = obj;
      this.gotoRoute(obj, act, row);
    } else {
      // Если модальный диалог - почистим карточку и наполним значениями
      obj.aftcardRem = obj.aftcard;
      obj.aftcard = card;
      for (var key in obj.recAdd) {
        obj.recAdd[key] = null;
      }
      ;
      this.setRecContent(obj, row);
      obj.aftfrmRec = true;
    }
  };

  // ----------------------------------------------------------------------------
  //                               tabDelete
  // ----------------------------------------------------------------------------

  this.tabDelete = function (obj, aAct) {
    var _this12 = this;
    var markids = [];
    var act = aAct === 'actDeleteP' ? 'actDeleteM' : aAct; // Физически удаляются только помеченные
    var dbact = aAct;

    // Подпора старых сорсов, когда текущая удаляемая автоматически помечалась
    // if ( aAct !== 'actDeleteM' && typeof(obj.aftenv.clickrow) === "undefined" && obj.aftenv.selected.length ) {
    //   act = 'actDeleteM'
    // }

    // При удалении должны быть либо помеченные либо задан clickrow
    if (!obj.aftenv.clickrow && !obj.aftenv.selected.length) {
      this.errFatal('$aft.tabDelete: No selected record');
      return;
    }
    ;
    if ('eventCapture' in obj && !obj.eventCapture('evnBeforeDelete')) {
      obj.aftloading = false;
      return;
    }
    ;
    var i;
    if (act === 'actDeleteM') {
      for (i = 0; i < obj.aftenv.selected.length; i++) {
        markids.push(obj.aftenv.selected[i].id);
      }
    } else {
      markids.push(obj.aftenv.clickrow.id);
    }

    // Сейчас основной режим - физическое удаление
    // Необходимость замены физического удаления логическим определяется флажком: aftobjDesc.logicaldel
    dbact = aAct !== 'actDeleteP' && 'aftobjDesc' in obj && obj.aftobjDesc.logicaldel ? 'actDelete' : 'actDeleteP';
    this.postDbAction(obj.aftobjCode, 'delete', {
      Ids: markids,
      Act: dbact
    }).then(function (response) {
      // console.log(response)
      if (examResponseError(obj, response)) {
        return 0;
      }
      if (act === 'actDeleteM') {
        for (i = 0; i < obj.aftenv.selected.length; i++) {
          obj.aftenv.data.remove(obj.aftenv.selected[i]);
        }
        obj.aftenv.selected = [];
      } else {
        obj.aftenv.data.remove(obj.aftenv.clickrow);
      }
      obj.aftloading = false;
    }).catch(function (error) {
      _this12.treateServerError(obj, error);
    });
  };

  // ----------------------------------------------------------------------------
  //                               tabRepairAddle
  // ----------------------------------------------------------------------------

  this.tabRepairAddle = function (obj) {
    var _this13 = this;
    var i;
    var markids = [];
    if (!obj.aftenv.selected.length && !obj.aftenv.clickrow) {
      this.errFatal('$aft.tabRepairAddle: No selected record');
      return;
    }
    if (obj.aftenv.selected.length) {
      for (i = 0; i < obj.aftenv.selected.length; i++) {
        markids.push(obj.aftenv.selected[i].id);
      }
    } else {
      markids.push(obj.aftenv.clickrow.id);
    }
    axios.post('repair_addle', {
      tab: obj.aftobjTabName,
      ids: markids
    }).then(function (response) {
      // console.log(response);
      for (i = 0; i < obj.aftenv.selected.length; i++) {
        obj.aftenv.data.remove(obj.aftenv.selected[i]);
      }
      obj.aftenv.selected = [];
      obj.aftloading = false;
    }).catch(function (error) {
      _this13.treateServerError(obj, error);
    });
  };

  // ----------------------------------------------------------------------------
  //                               recOk
  // ----------------------------------------------------------------------------

  // eslint-disable-next-line no-unused-expressions
  this.recOk = function (obj) {
    var _this14 = this;
    var key,
      evnsuf = 'Insert',
      dbact = 'add';
    if (obj.aftcard === 'cardRse') {
      this.tabSelect(obj);
      obj.aftfrmRse = false;
      obj.aftloading = false;
      return;
    }
    ;
    if (obj.aftcard === 'cardList') {
      for (key in obj.aftobjFrom.recAdd) {
        if (key in obj.aftenv.selected[0]) {
          obj.aftobjFrom.recAdd[key] = obj.aftenv.selected[0][key];
        }
      }
      ;
      obj.aftfrmList = false;
      obj.aftloading = false;
      return;
    }
    ;
    if (obj.aftcard === 'cardUpdate') {
      evnsuf = 'Update';
      dbact = 'update';
    }
    ;
    if ('eventCapture' in obj) {
      var res = obj.eventCapture('evnBefore' + evnsuf);
      if (!res) {
        obj.aftloading = false;
        return;
      }
    }
    ;
    this.postDbAction(obj.aftobjCode, dbact, obj.recAdd).then(function (response) {
      // console.log(response.data);
      if (examResponseError(obj, response)) {
        return;
      }
      if ('eventCapture' in obj && !obj.eventCapture('evnAfter' + evnsuf)) {
        obj.aftloading = false;
        return;
      }
      ;
      if ('id' in response.data && response.data.id !== null) {
        obj.recAdd.id = response.data.id;
      }
      obj.recAdd.UserName = response.data.UserName;

      // Переносим данные в таблицу (entry: carTab/cardList)
      // this.rec2tab(obj) похоже тут не канает контекст this, тело функции вставлено явно
      // Данные переносятся в кэш, т.е. можно не париться о режиме RecPage

      if (obj.isTabEntry()) {
        var newrec = {};
        Object.assign(newrec, obj.recAdd);
        if (obj.aftcard === 'cardAdd') {
          _this14.g.obj[obj.aftobjCode].env.data.push(newrec);
        }
        ;
        if (obj.aftcard === 'cardUpdate') {
          if (obj.aftenv.selected.length) {
            // Редактирование "помеченных" сейчас не используется
            // При необходимости реанимировать сей функционал, надо разбираться с взаимодействием пейджов таб-а и рек-а
            for (var i = 0; i < _this14.g.obj[obj.aftobjCode].env.selected.length; i++) {
              newrec.id = _this14.g.obj[obj.aftobjCode].env.selected[i].id;
              var idx = _this14.g.obj[obj.aftobjCode].env.data.indexOf(_this14.g.obj[obj.aftobjCode].env.selected[i]);
              _this14.g.obj[obj.aftobjCode].env.data.splice(idx, 1, newrec);
              // obj.aftenv.selected[i] = newrec
            }
            _this14.g.obj[obj.aftobjCode].env.selected = [];
          } else {
            // При переходе на пейдж записи, запомнили row, в который кликнули
            // Тут надо считаться, что при работе с карточкой записи, могли нажать F5 и скинуть все запоминалки
            // Концепция возврата на табличный пейдж будет такая:
            //     ... если F5 не нажимали, то в таблице подменим старую запись на новую
            //     ... если F5 нажали, то и данных в таблице тоже уже нет, подменять нечего,
            //         при возврате на cardTab таблица будет проинициализирована заново

            // if (obj.aftenv.clickrow) {
            //   const idx = obj.aftenv.data.indexOf(obj.aftenv.clickrow)
            //   obj.aftenv.data.splice(idx, 1, newrec)
            // }

            // Все гораздо хуже ...
            // Запомнить row получается не всегда, хук row-click при переходе в карточку редактирования
            // через link отрабатывает только первый раз, собака ... Т.е. с "запоминанием" можно
            // корректно обновить в таблице только одну запись, потом надо делать F5, иначе хук протухает!
            // Ничего не остается, как искать в таблице строку по id. А если такого поля нет, то будем
            // просто сбрасывать кеш объекта, чтобы при возврате на табл.карточку таблица перечиталась.
            if ('id' in newrec && obj.aftenv.data.length) {
              var _idx = 0;
              for (; _idx < obj.aftenv.data.length && obj.aftenv.data[_idx].id !== newrec.id; _idx++) {}
              obj.aftenv.data.splice(_idx, 1, newrec);
            } else {
              delete _this14.g.obj[obj.aftobjCode];
            }
          }
        }
      }

      // Если редактирование или не потоковый ввод или entry: carTab/cardList,
      // закроем карточку (для модального режима) или вернемся в объект vue табличной карточки

      if (obj.aftcard === 'cardUpdate' || !obj.inMode(MODE.Stream) || obj.aftobjEntry === ENTRY.cardTab || obj.aftobjEntry === ENTRY.cardList) {
        if (!obj.inMode(MODE.recpage)) {
          // Модальный диалог
          obj.aftfrmRec = false;
        } else {
          // Страничная карточка
          _this14.objRec = obj;
          // obj.$router.push('/' + obj.aftobjCode)

          _this14.gotoRoute(obj, 'actOk');

          // obj.$router.go(-1)
        }
      }
      ;
      obj.aftloading = false;
    }).catch(function (error) {
      _this14.treateServerError(obj, error);
    });
  };

  // ----------------------------------------------------------------------------
  //                               recReturn
  // ----------------------------------------------------------------------------

  // this.recReturn = function (obj) {
  //   this.objRec = obj
  //   obj.$router.go(-1)
  //   // obj.$router.push('/' + obj.aftobjCode)
  // }

  // ----------------------------------------------------------------------------
  //                               rec2tab
  // ----------------------------------------------------------------------------

  // Переносит данные из recAdd в таблицу
  // Данные переносятся в кэш, т.е. можно не париться о режиме RecPage

  // this.rec2Tab = function (obj) {
  //   const newrec = {}

  //   Object.assign(newrec, obj.recAdd)
  //   if (obj.aftcard === 'cardAdd') {
  //     this.g.obj[obj.aftobjCode].env.data.push(newrec)
  //   };
  //   if (obj.aftcard === 'cardUpdate') {
  //     for (var i = 0; i < this.g.obj[obj.aftobjCode].env.selected.length; i++) {
  //       newrec.id = this.g.obj[obj.aftobjCode].env.selected[i].id
  //       const idx = this.g.obj[obj.aftobjCode].env.data.indexOf(this.g.obj[obj.aftobjCode].env.selected[i])
  //       this.g.obj[obj.aftobjCode].env.data.splice(idx, 1, newrec)
  //       // obj.aftenv.selected[i] = newrec
  //     }
  //     this.g.obj[obj.aftobjCode].env.selected = []
  //   }
  // }

  // ----------------------------------------------------------------------------
  //                               recValid
  // ----------------------------------------------------------------------------

  this.recValid = function (obj, chks) {
    var i,
      err = false,
      res,
      fldname;
    for (i = 0; i < chks.length; i++) {
      if (_typeof(chks[i]) === 'object') {
        if (!chks[i].fun || !chks[i].inp && !chks[i].fld) {
          this.errFatal('$aft.recValid/chks invalid');
        }
        fldname = chks[i].fld || chks[i].inp;
        if (!(chks[i].fun in obj)) {
          this.errFatal("$aft.recValid/chkfun '" + chks[i].fun + "' not found in object");
        }
        res = obj[chks[i].fun](obj[fldname], fldname, chks[i].inp);
        if (res === true) {
          continue;
        } // все хорошо
        err = true;
        continue;
        // Попытка программно взвести флажок ошибки и установить мессадж у контрола не прокатывают,
        // спец методов нет, а усли менять свойства props - мутэйтинг
        // Всю эту работу должна делать chk - функция
        // if (!chks[i].inp) { continue } // контрол не задан, нах
        // if (!obj.$refs[chks[i].inp]) {
        //   this.errFatal("$aft.recValid/chks[i].inp '" + chks[i].inp + "' not found in refs")
        // }
        // obj.$refs[chks[i].inp].error = true
        // // А теперь попробуем показать сообщение
        // if (typeof (res) === 'string' && chks[i].opt && CHK.exam(chks[i].opt, CHK.showmess)) {
        //   obj.$refs[chks[i].inp]['error-message'] = res
        // }
      } else {
        var refobj = obj.$refs[chks[i]];
        if (typeof refobj === 'undefined' || !refobj) {
          this.errFatal("$aft.recValid/chks '" + chks[i] + "' not found in refs");
        }

        // Проверим readonly & disable - валидатора для таких состояний нет!
        if (refobj.readonly || refobj.disable) {
          continue;
        }

        // Ref-ом может быть помечена компонента более высокого уровня, например aft-date-time
        // Для такой компоненты атрибут "rules" транзитом падает дочернему компоненту q-input
        // В этом случае валидация должна делаться именно в дочернем компоненте, имеющим метод validate
        // Пока заложимся, только на глубину 1
        if (refobj.aViewmode) {
          // ... режим просмотра - валидация не нужна
          continue;
        }
        if (typeof refobj.validate === 'undefined') {
          for (var j = 0; j < refobj.$children.length; j++) {
            if (typeof refobj.$children[j].validate !== 'undefined') {
              refobj = refobj.$children[j];
              break;
            }
          }
        }
        if (refobj.readonly || refobj.disable) {
          continue;
        }
        if (typeof refobj.validate === 'undefined') {
          this.errFatal("$aft.recValid/validate. Component '" + chks[i] + "' has't validate function");
        }
        refobj.validate();
        err = err || refobj.hasError;
      }
    }
    ;
    if (err) {
      obj.formHasError = true;
      msgerror(obj.$t('com.msg.chkRec'));
    }
    ;
    return !err;
  };

  // ----------------------------------------------------------------------------
  //                               recClear
  // ----------------------------------------------------------------------------

  this.recClear = function (obj, act) {
    var rec = obj.aftfrmRse || act === 'actClearRse' ? obj.recRse : obj.recAdd;
    for (var key in rec) {
      if (key === 'Actual') {
        continue;
      }
      if (key in obj.$refs && (typeof obj.$refs[key] === 'undefined' || typeof obj.$refs[key].readonly === 'undefined' || !obj.$refs[key].readonly)) {
        if (typeof rec[key] === 'boolean') {
          rec[key] = false;
        } else {
          rec[key] = null;
        }
      }
    }
    ;
  };

  // ----------------------------------------------------------------------------
  //                               fldUpdate
  // ----------------------------------------------------------------------------

  this.fldUpdate = function (obj, row, fldname) {
    var _this15 = this;
    var fldval = row[fldname];
    axios.post('/update_' + obj.aftobjCode + '_field', {
      fieldName: fldname,
      id: row.Id,
      val: fldval
    }).then(function (response) {
      // console.log(response)
      obj.aftloading = false;
    }).catch(function (error) {
      _this15.treateServerError(obj, error);
    });
  };
  Vue.set(this, 'accountName', ACCNAME_INIT);
} // AFT class

// ----------------------------------------------------------------------------
//                                  aftInst  $aft
// ----------------------------------------------------------------------------

export var aftInst = new AFT();
export default (/*#__PURE__*/function () {
  var _ref9 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee8(_ref8) {
    var Vue;
    return _regeneratorRuntime.wrap(function _callee8$(_context8) {
      while (1) switch (_context8.prev = _context8.next) {
        case 0:
          Vue = _ref8.Vue;
          Vue.prototype.$aft = aftInst;
        case 2:
        case "end":
          return _context8.stop();
      }
    }, _callee8);
  }));
  return function (_x15) {
    return _ref9.apply(this, arguments);
  };
}());

// ----------------------------------------------------------------------------
//                       getCookie setCookie deleteCookie
// ----------------------------------------------------------------------------

// возвращает cookie с именем name, если есть, если нет, то "undefined" (и это так!!!)
export function getCookie(name) {
  var matches = document.cookie.match(new RegExp('(?:^|; )' + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + '=([^;]*)'));
  return matches ? decodeURIComponent(matches[1]) : undefined;
}

// устанавливает cookie с именем name и значением value
// options - объект с свойствами cookie (expires, path, domain, secure)
export function setCookie(name, value, options) {
  options = options || {};
  var expires = options.expires;
  if (typeof expires === 'number' && expires) {
    var d = new Date();
    d.setTime(d.getTime() + expires * 1000);
    expires = options.expires = d;
  }
  if (expires && expires.toUTCString) {
    options.expires = expires.toUTCString();
  }
  value = encodeURIComponent(value);
  var updatedCookie = name + '=' + value;
  for (var propName in options) {
    updatedCookie += '; ' + propName;
    var propValue = options[propName];
    if (propValue !== true) {
      updatedCookie += '=' + propValue;
    }
  }
  document.cookie = updatedCookie;
}

// удаляет cookie с именем name
export function deleteCookie(name) {
  this.setCookie(name, '', {
    expires: -1
  });
}
function onfocushook() {
  // Проверяем, что пользователь не авторизовался на другой страничке с другим логином
  // Если да, то отправляем на основную страничку
  if ("smart$login" in localStorage && localStorage["smart$login"] !== 'undefined' && localStorage["smart$login"] !== 'null' && localStorage["smart$login"] !== aftInst.g.auth.accLogin) {
    aftInst.clearClientAuth();
    window.location.hash = '/$reauth$';
    location.reload(true);
  }
}
window.onfocus = onfocushook;

// ----------------------------------------------------------------------------
//                                  errorHandler
// ----------------------------------------------------------------------------

// Vue.config.errorHandler = (err, vm, info) => {

//     function getaftObj(vueobj) {
//       let aftobj = vueobj.$options.parent
//       if ( typeof(aftobj) === "undefined" ) { return null }
//       if ( "aftobjCode" in aftobj ) { return aftobj }
//       return getaftObj(aftobj)
//     }

//   if (typeof(aftInst) === "undefined") { throw Error }

//   let aftobj = getaftObj(vm)
//   let aftobjcode = aftobj ? aftobj.aftobjCode : ''
//   if ( aftobj ) {
//     aftobj.aftloading = false
//   }
//   aftInst.errFatal('Vue error. aftObjCode: "' + aftobjcode + '  Error: ' + err.message)
//   throw Error
// };